import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "enums";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import DeliverLogsModule from "modules/inventory/delivery-logs/delivery-logs.module";
import DeliverLogDetailsModule from "modules/inventory/delivery-logs/delivery-log-details/delivery-log-details.module";
import PurchaseOrderModule from "modules/inventory/purchase-order/purchase-order.module";
import PurchaseOrderDetailsModule from "modules/inventory/purchase-order/purchase-order-details/purchase-order-details.module";

const InventoryPage = () => {
  return (
    <Switch>
      <Route exact path={Path.DeliveryLogs} component={DeliverLogsModule} />
      <Route exact path={Path.AddDeliveryLog} component={DeliverLogDetailsModule} />
      <Route exact path={Path.DeliveryLogDetails} component={DeliverLogDetailsModule} />

      <Route exact path={Path.PurchaseOrder} component={PurchaseOrderModule} />
      <Route exact path={Path.AddPurchaseOrder} component={PurchaseOrderDetailsModule} />
      <Route exact path={Path.PurchaseOrderDetails} component={PurchaseOrderDetailsModule} />
      <Redirect to={Path.DeliveryLogs} />
    </Switch>
  );
};

export default InventoryPage;
